import { render } from "./Tipologie.vue?vue&type=template&id=655d3af5"
import script from "./Tipologie.vue?vue&type=script&lang=js"
export * from "./Tipologie.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__